import { computed, makeObservable, observable, toJS } from 'mobx'

import { getStoredIncludeMyDbProblem } from '@/service/includeMyDbProblemStorage'

import { DTO } from '../DTO'
import type { MakeWorksheetFilterOption } from './MakeWorksheetFilterOption'

export class MakeWorksheetByChapterOption extends DTO {
  filterId = '' // 필터 고유 아이디

  // 공통
  type: common.MakeWorksheetBy = 'CONCEPT' // TODO - fix 학습지만들기 1단계가 어떤건지 : 'CONCEPT' - 단원유형 PUBLIC_WORKBOOK - 시중교재 PRACTICE_TEST - 수능 모의고사
  conceptIdList: number[] = [] // 유형 선택 아이디리스트
  excludedTopicIds: number[] = [] // 제외할 주제(유형) id list
  excludedSubTopicIds: number[] = [] // 제외할 세부(유형) id list
  problemCount = 50 // 문제 수
  level: common.ProblemLevel = 3 // 문제 난이도
  levelWeight: [number, number, number, number, number] = [0, 0, 100, 0, 0]
  problemFilterType: common.ProblemFilterType = 'ALL'
  practiceTest: common.PracticeTestOption = 'INCLUDE' // 모의고사 문제 포함여부 - include: 문제 포함, only: 문제만, exclude: 문제 제외
  onlyAutoScorable = true // 자동채점 가능여부
  excludePrevious = false // 기존 출제문제 제외여부
  previousExclusionScope?: common.PreviousExclusionScope // 기존 출제 문제 제외 기준
  studentIds?: res.Student['id'][] // 제외 기준이 STUDENT_ASSIGNED일 때 대상 학생 id 목록
  excludeOOC = true // 교육과정 외 유형 제외
  includeMyDbProblem = getStoredIncludeMyDbProblem() // 본인 업로드(나의 DB) 문제 포함 여부 — 최종 생성 시점 값 복원
  equalityLevel: common.MakeWorksheetEqualityLevel = null // 균등배분시 기준 - 선택 안하면 null
  minRate = 0 // 정답률 - 최대
  maxRate = 100 // 정답률 - 최대
  problemList:
    | {
        id: number
        tagTop: res.Problem<'WORKSHEET'>['tagTop']
        baseWorkbookProblemId?: number | null
      }[]
    | null = null
  title?: string
  selectedConceptIdList: number[] = [] // 선택한 유형별 개념
  selectedLittleChapterIdList: number[] = [] // 선택한 소단원별 개념
  source?: MakeWorksheetFilterOption['source']

  constructor(data?: Partial<MakeWorksheetByChapterOption>) {
    super()

    if (data) {
      Object.assign(this, data)
    }

    makeObservable(this, {
      filterId: observable,
      practiceTest: observable,
      onlyAutoScorable: observable,
      excludePrevious: observable,
      previousExclusionScope: observable,
      studentIds: observable,
      problemFilterType: observable,
      excludeOOC: observable,
      includeMyDbProblem: observable,
      type: observable,

      conceptIdList: observable,
      excludedTopicIds: observable,
      excludedSubTopicIds: observable,
      problemCount: observable,
      level: observable,
      levelWeight: observable,
      equalityLevel: observable,
      minRate: observable,
      maxRate: observable,
      problemList: observable,
      title: observable,
      selectedConceptIdList: observable,
      selectedLittleChapterIdList: observable,
      params: computed,
    })
  }

  get params(): req.CreateFilterByChapter {
    const params = {
      practiceTest: this.practiceTest,
      onlyAutoScorable: this.onlyAutoScorable,
      excludePrevious: this.excludePrevious,
      problemFilterType: this.problemFilterType,
      conceptIdList: toJS(this.conceptIdList),
      excludedTopicIds: this.excludedTopicIds,
      excludedSubTopicIds: this.excludedSubTopicIds,
      problemCount: this.problemCount,
      level: this.level,
      levelWeight: this.levelWeight,
      excludeOOC: this.excludeOOC,
      includeMyDbProblem: this.includeMyDbProblem,
      equalityLevel: this.equalityLevel,
      minRate: this.minRate,
      maxRate: this.maxRate,
      problemList: toJS(this.problemList) || null,
      selectedConceptIdList: this.selectedConceptIdList,
      selectedLittleChapterIdList: this.selectedLittleChapterIdList,
      source: this.source,
    }

    if (this.title) {
      params['title'] = this.title
    }
    if (this.filterId) {
      params['filterId'] = this.filterId
    }
    if (this.excludePrevious && this.previousExclusionScope) {
      params['previousExclusionScope'] = this.previousExclusionScope
      if (this.previousExclusionScope === 'STUDENT_ASSIGNED' && this.studentIds?.length) {
        params['studentIds'] = this.studentIds
      }
    }

    return params
  }
}
